<div
  class="rounded border border-stroke-muted p-5 flex flex-row flex-start gap-4 transition-colors"
  [ngClass]="{ 'border-stroke-primary-emphasis': value() }"
>
  <button
    type="button"
    class="cursor-pointer option-icon rounded p-2 h-min transition-colors empty:hidden"
    [ngClass]="{
      'bg-bg-secondary-bolder text-white option-icon--active': value(),
      'bg-bg-alt  text-fg-secondary-emphasis': !value(),
    }"
    (click)="toggle()"
  >
    <ng-content select="svg"></ng-content>
  </button>
  <div class="flex flex-col gap-1 flex-1">
    <h6 class="title-xs"><ng-content></ng-content></h6>
    <p class="body-xs text-fg-muted max-text-block-width">
      <ng-content select="description"></ng-content>
    </p>
  </div>
  <div>
    <ep-toggle [value]="value()" (change)="toggle()"></ep-toggle>
  </div>
</div>
